// extracted by mini-css-extract-plugin
export default {"clickable":"UserCard_clickable__+dOIC","name-container":"UserCard_name-container__1N2Aq","name-text":"UserCard_name-text__jKgPu"};